module.exports = __webpack_public_path__ + "static/media/pn.1497811b.svg";